import { Component } from '@angular/core';

@Component({
  templateUrl: './maintenance.component.html',
  standalone: false,
})
export class MaintenanceComponent {}
